"use strict";var inherit = require("raptor-util/inherit");
var domData = require("../components/dom-data");
var keysByDOMNode = domData._p_;
var vElementByDOMNode = domData._M_;
var createFragmentNode = require("./morphdom/fragment")._m_;
var VNode = require("./VNode");

function VFragment(key, ownerComponent, preserve) {
  this.bY_(null /* childCount */, ownerComponent);
  this.ca_ = key;
  this.af_ = preserve;
}

VFragment.prototype = {
  c__: 12,
  br_: function () {
    var fragment = createFragmentNode();
    keysByDOMNode.set(fragment, this.ca_);
    vElementByDOMNode.set(fragment, this);
    return fragment;
  }
};

inherit(VFragment, VNode);

module.exports = VFragment;